import { render, staticRenderFns } from "./EvaluationStatisticsV3.vue?vue&type=template&id=57b738d2&scoped=true"
import script from "./EvaluationStatisticsV3.vue?vue&type=script&lang=js"
export * from "./EvaluationStatisticsV3.vue?vue&type=script&lang=js"
import style0 from "./EvaluationStatisticsV3.vue?vue&type=style&index=0&id=57b738d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b738d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b738d2')) {
      api.createRecord('57b738d2', component.options)
    } else {
      api.reload('57b738d2', component.options)
    }
    module.hot.accept("./EvaluationStatisticsV3.vue?vue&type=template&id=57b738d2&scoped=true", function () {
      api.rerender('57b738d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/v3/EvaluationStatisticsV3.vue"
export default component.exports